// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1732":"75ae7cf5","2094":"c40216d1"}[chunkId] + ".chunk.css";
};